import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { defaultFilters } from '../../../../../views/Remediation/remediation.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/')({
  validateSearch: zodValidator(withDefaults(schema.REMEDIATION, defaultFilter, defaultFilters)),
  search: {
    middlewares: [stripSearchParams({ ...defaultFilter, ...defaultFilters })],
  },
});
